import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
    REQUEST_FAVORITES,
    FETCH_FAVORITES_SUCCESS,
    FETCH_FAVORITES_FAILURE,
    SELECT_FAVORITES,
    RESET_CURRENT_FAVORITES,
    REQUEST_FAVORITES_DETAIL,
    FETCH_FAVORITES_DETAIL_SUCCESS,
    FETCH_FAVORITES_DETAIL_FAILURE,
    REQUEST_ADDING_FAVORITE,
    ADD_FAVORITE_SUCCESS,
    ADD_FAVORITE_FAILURE,
    REQUEST_DELETE_FAVORITE,
    DELETE_FAVORITE_SUCCESS,
    DELETE_FAVORITE_FAILURE,
    REQUEST_ADDING_NEW_FAVORITE_LIST,
    ADD_NEW_FAVORITE_LIST_SUCCESS,
    ADD_NEW_FAVORITE_LIST_FAILURE,
    REQUEST_FAVORITE_LIST,
    FETCH_FAVORITE_LIST_SUCCESS,
    FETCH_FAVORITE_LIST_FAILURE,
    REQUEST_SAVE_FAVORITE_LIST,
    SAVE_FAVORITE_LIST_SUCCESS,
    SAVE_FAVORITE_LIST_FAILURE,
} from './type'

import {
    FAVORITES_URL,
    INVENTORIES_URL,
    CUSTOMERS_WITH_FAVORITES_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

// Inventories Actions

export function fetchFavorites() {
    return dispatch => {
        dispatch({ type: REQUEST_FAVORITES });
        return axios.get(FAVORITES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchFavoritesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchFavoritesFailure(err));                     
              }
            });
    }
}

export function fetchFavoritesSuccess(favorites) {
    return {
        type: FETCH_FAVORITES_SUCCESS,
        payload: favorites
    };
}

export function fetchFavoritesFailure(error) {
    return {
        type: FETCH_FAVORITES_FAILURE,
        payload: error
    };
}

export function selectFavorites(favorites) {
    return {
        type: SELECT_FAVORITES,
        payload: favorites
    };
}

export function resetCurrentFavorites() {
    return {
        type: RESET_CURRENT_FAVORITES
    }
}


export function fetchFavoritesDetail(favorites_id) {
    return dispatch => {
        dispatch({ type: REQUEST_FAVORITES_DETAIL });
        return axios.get(FAVORITES_URL + favorites_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchFavoritesDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchFavoritesDetailFailure(err));                     
              }
            });
    }
}

export function fetchFavoritesDetailSuccess(favoritesDetail) {
    return {
        type: FETCH_FAVORITES_DETAIL_SUCCESS,
        payload: favoritesDetail
    };
}

export function fetchFavoritesDetailFailure(error) {
    return {
        type: FETCH_FAVORITES_DETAIL_FAILURE,
        payload: error
    };
}

export function addNewFavorite({
    Product_id,
    ProductNum,
    RefNum,
    ProductName,
    PreSale,
    InStock,
    Ordered,
    Price
}) {
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_FAVORITE });
      axios.post(FAVORITES_URL,
          {
              Product_id,
              ProductNum,
              RefNum,
              ProductName,
              PreSale,
              InStock,
              Ordered,
              Price
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addFavoriteSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(addFavoriteFailure(err));                   
            }
          });
  }
}

export function addFavoriteSuccess() {
    return {
      type: ADD_FAVORITE_SUCCESS,
    }
}

export function addFavoriteFailure(response) {
    return {
      type: ADD_FAVORITE_FAILURE,
      payload: response
    }
}

export function deleteFavorite(Product_id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_FAVORITE });
      axios.delete(FAVORITES_URL + Product_id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(deleteFavoriteSuccess());
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(deleteFavoriteFailure());                 
          }
        });
  }
}

export function deleteFavoriteSuccess() {
    return {
      type: DELETE_FAVORITE_SUCCESS,
    }
}

export function deleteFavoriteFailure(response) {
    return {
      type: DELETE_FAVORITE_FAILURE,
      payload: response
    }
}

export function addNewFavoriteList(Customer_id) {
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_NEW_FAVORITE_LIST });
      axios.post(CUSTOMERS_WITH_FAVORITES_URL + Customer_id,
          {},
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addFavoriteSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(addFavoriteFailure(err));                   
            }
          });
  }
}

export function fetchFavoriteList(pk, Company_id = '', Warehouse_id = '') {
  return dispatch => {
      dispatch({ type: REQUEST_FAVORITE_LIST });
      const params = {};
      if (Company_id) {
        params.Company_id = Company_id;
      }
      if (Warehouse_id) {
        params.Warehouse_id = Warehouse_id;
      }
      return axios.get(CUSTOMERS_WITH_FAVORITES_URL + pk,
          { 
            params,
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          })
          .then(response => {
            dispatch(fetchFavoriteListSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(fetchFavoriteListFailure(err));                   
            }
          });
  }
}

export function fetchFavoriteListSuccess(list) {
  return {
    type: FETCH_FAVORITE_LIST_SUCCESS,
    payload: list
  }
}

export function fetchFavoriteListFailure(error) {
  return {
    type: FETCH_FAVORITE_LIST_FAILURE,
    payload: error
  }
}

export function saveFavoriteList({
  Customer_id,
  Sales_FavoriteList_Lines
}) {
  return dispatch => {
      dispatch({ type: REQUEST_SAVE_FAVORITE_LIST });
      axios.post(CUSTOMERS_WITH_FAVORITES_URL,
          {
            Customer_id,
            Sales_FavoriteList_Lines
          },
          {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(saveFavoriteListSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(saveFavoriteListFailure(err));                   
            }
          });
  }
}

export function saveFavoriteListSuccess() {
    return {
      type: SAVE_FAVORITE_LIST_SUCCESS,
    }
}

export function saveFavoriteListFailure(error) {
    return {
      type: SAVE_FAVORITE_LIST_FAILURE,
      payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/favorites_actions.jsx